import React from 'react';
import { useParams } from 'react-router-dom';

import FillInTheBlanksExercisePreview from '@ts-core/modules/fillInTheBlanksExercises/components/FillInTheBlanksExercisePreview';

import { useFillInTheBlanksExercise } from '../../hooks';

const FillInTheBlanksExercisePreviewPage = () => {
  const { courseId, subjectId, exerciseId } = useParams<{ courseId: string; subjectId: string; exerciseId?: string }>();
  const { exercise, loading } = useFillInTheBlanksExercise({ courseId, subjectId, exerciseId });
  return <FillInTheBlanksExercisePreview exercise={exercise} loading={loading} hideQuestionBackgroundColor hideScores />;
};

export default FillInTheBlanksExercisePreviewPage;
